module.exports = __webpack_public_path__ + "img/banner_xiuduyou.880e8260.png";